import styled from '@emotion/styled';

export const Root = styled.div`
  margin-bottom: 20px;
  svg {
    margin-bottom: -7px;
  }
`